
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer_2"}},[_c('path',{staticClass:"st0",attrs:{"d":"M14.8 17.2H4V5.5C4 4.7 4.7 4 5.5 4h9.3v13.2zM14.8 28H5.5c-.8 0-1.5-.7-1.5-1.5v-6.9h10.8V28zM28 12.4H17.2V4h9.3c.8 0 1.5.7 1.5 1.5v6.9zM26.5 28h-9.3V14.8H28v11.7c0 .8-.7 1.5-1.5 1.5z"}})])])
          )
        }
      }
    